const loadJitsiScript = sessao => {
    return new Promise(resolve => {
        if (!sessao) {
            resolve(false);
            return;
        }

        const script = document.createElement("script");
        script.src = `https://${sessao.servidor}/external_api.js`;
        script.async = true;
        script.onload = () => resolve(true);
        document.body.appendChild(script);
    });
};

export default loadJitsiScript;
